import { render } from "./Reactive.vue?vue&type=template&id=64b657ed"
import script from "./Reactive.vue?vue&type=script&lang=ts"
export * from "./Reactive.vue?vue&type=script&lang=ts"
script.render = render

export default script